import { Button, Box, Typography, Paper, Divider, useTheme } from "@mui/material";
import { useState } from "react";
import DataGridMAIQ from "app/components/DataGridMAIQ";
import DataGridTypes from "types/DataGridTypes";
import AddResourceModal from "./AddResourceModal";
import ResourceDetailsModal from "./ResourceDetailsModal";
import { Resource } from "../../types";
import AddIcon from '@mui/icons-material/Add';
import SettingsIcon from '@mui/icons-material/Settings';

const ResourcesTab = () => {
  const [isAddResourceModal, setIsAddResourceModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedResource, setSelectedResource] = useState<Resource | null>(null);
  const theme = useTheme();

  const handleAddResourceModalOpen = () => {
    setIsAddResourceModal(true);
  };

  const handleResourceClick = (resource: any) => {
    setSelectedResource(resource.row);
  };

  const handleCloseResourceDetails = () => {
    setSelectedResource(null);
  };

  return (
    <Box 
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        height: "100%",
        padding: { xs: 1, sm: 2 }
      }}
    >
      <Paper 
        elevation={0}
        sx={{ 
          p: 2.5,
          display: "flex",
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: "space-between",
          alignItems: { xs: 'flex-start', sm: 'center' },
          borderRadius: 1.5,
          backgroundColor: 'background.paper',
          boxShadow: '0 2px 8px rgba(15, 40, 76, 0.05)',
          gap: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <SettingsIcon 
            sx={{ 
              color: theme.palette.secondary.main,
              fontSize: 28 
            }} 
          />
          <Box>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                fontSize: '1.1rem',
                color: theme.palette.secondary.main
              }}
            >
              Resource Management
            </Typography>
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ fontSize: '0.85rem' }}
            >
              Create and manage system resources
            </Typography>
          </Box>
        </Box>
        
        <Button
          variant="contained"
          color="secondary"
          onClick={handleAddResourceModalOpen}
          startIcon={<AddIcon />}
          sx={{
            borderRadius: 1,
            textTransform: 'none',
            fontWeight: 600,
            px: 2.5,
            py: 1,
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
              backgroundColor: '#0a1f3a',
              boxShadow: '0 4px 10px rgba(15, 40, 76, 0.2)',
            },
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          Add New Resource
        </Button>
      </Paper>
      
      <Divider sx={{ opacity: 0.5 }} />

      <Box 
        sx={{ 
          flexGrow: 1, 
          minHeight: 400,
          '& .MuiDataGrid-root': {
            border: 'none',
            borderRadius: 1.5,
            boxShadow: '0 2px 8px rgba(15, 40, 76, 0.05)',
          },
        }}
      >
        <DataGridMAIQ 
          key={refreshKey}
          type={DataGridTypes.RESOURCES()}
          onRowClick={handleResourceClick}
        />
      </Box>

      <AddResourceModal
        open={isAddResourceModal}
        onClose={() => setIsAddResourceModal(false)}
        onSuccess={() => setRefreshKey(prev => prev + 1)}
      />
      {selectedResource && (
        <ResourceDetailsModal
          open={!!selectedResource}
          onClose={handleCloseResourceDetails}
          resource={selectedResource}
          onSuccess={() => {
            setRefreshKey(prev => prev + 1);
            handleCloseResourceDetails();
          }}
        />
      )}
    </Box>
  );
};

export default ResourcesTab; 